
























































































































import Vue from 'vue';
import ToastPreview from './ToastPreview.vue';

export default Vue.extend({
    props: {
        formDataToEdit: {
            type: Object,
            default: () => ({} as any),
        },
        typeList: {
            required: true,
            type: Array,
        },
        formMode: {
            type: String,
        },
        value: {
            type: Boolean,
            default: false,
        },
        toastType: {
            type: Object,
        },
        dateRange: {
            required: true,
            type: Array,
        },
        userId: {
            type: Number,
        },
        title: {
            type: String,
        },
    },
    components: {
        ToastPreview,
    },
    data() {
        return {
            showPreview: false,
            render: '',
            toastData: {},
            updateRangeText: '',
            type: {} as any,
            dates: [] as any,
            show: false,
            loading: false,
            formData: {} as any,
        };
    },
    watch: {
        dates() {
            if (this.dates.length === 2) {
                this.formData.activeSince = this.dates[0] as string;
                this.formData.activeUntil = this.dates[1] as string;
                this.renderForm();
            }
        },
        value(isVisible) {
            if (isVisible) {
                if (this.formMode === 'edit') {
                    this.type = this.toastType;
                    this.dates = this.dateRange;
                    this.formData.id = this.formDataToEdit.id;
                    this.formData.active = this.formDataToEdit.active;
                    this.formData.name = this.formDataToEdit.name;
                    this.formData.title = this.formDataToEdit.title;
                    this.formData.activeUntil = this.dateRange[0] as string;
                    this.formData.activeSince = this.dateRange[1] as string;
                    this.formData.subtitle = this.formDataToEdit.subtitle;
                    this.formData.content = this.formDataToEdit.content;
                    this.formData.style = this.formDataToEdit.style;
                    this.formData.iconName = this.formDataToEdit.iconName;
                } else {
                    // new toast
                    this.type = {};
                    this.dates = this.dateRange;
                    this.formData.id = null;
                    this.formData.active = true;
                    this.formData.name = null;
                    this.formData.title = null;
                    this.formData.activeUntil = null;
                    this.formData.activeSince = null;
                    this.formData.subtitle = null;
                    this.formData.content = null;
                    this.formData.style = null;
                    this.formData.iconName = null;
                }
            }

        },
    },
    methods: {
        updateStyle() {
            this.formData.style = this.type.style;
            this.formData.iconName = this.type.value;
            this.renderForm();
        },
        async handleSubmit() {
            // @ts-ignore
            if (this.$refs.setupModal.validate()) {
                this.loading = true;
                let errorMsg = 'Failed to add Toast';
                try {
                    if (this.formMode === 'edit') {
                        const res = await this.$hipApi.editToast(this.formData.id, this.formData);
                        this.$notifier.showSuccess('Successfully updated');
                    } else {
                        const res = await this.$hipApi.addToast(this.formData);
                        this.$notifier.showSuccess('Successfully added a new Toast');
                    }

                    this.show = false;
                    this.closeForm();
                } catch (error) {
                    const errMsg = (error?.error?.message || error?.message || error);
                    if (errMsg.includes('overlaping dates')) {
                        errorMsg = 'Failed to add Toast. Can\'t have 2 toasts with overlaping dates';
                    }
                    this.$notifier.showError(errorMsg);
                }
                this.loading = false;
            }

        },

        closeForm() {
            this.$emit('input', false);
            // @ts-ignore
            this.$refs.setupModal.reset();
            this.dates = [];
            this.type = {};
            this.toastData = {};
            this.$emit('closedForm');

        },
        renderForm() {
            this.showPreview = this.formData.title != null || this.formData.subtitle != null || this.formData.style != null;
            this.toastData = {};
            this.render = '';

            this.toastData = this.formData;
            this.render = new Date().toString();
        },
    },

    created() {
        this.show = true;
    },
});
